import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import { PATHS } from "../../../constants/paths";

const MailAmbitionPage = lazy(() => import("../MailAmbition"));
const TemplatesPage = lazy(() => import("../tabs/TemplatesTab"));
const ReportingPage = lazy(() => import("../tabs/ReportingTab"));

const useMailAmbitionRoutes = () => (
  <Route path={PATHS.MailAmbition.Path} element={<MailAmbitionPage />}>
    <Route
      path={PATHS.MailAmbition.Tabs.Templates.Path}
      element={<TemplatesPage />}
    />
    <Route
      path={PATHS.MailAmbition.Tabs.Reporting.Path}
      element={<ReportingPage />}
    />
    <Route
      index
      element={<Navigate replace to={PATHS.MailAmbition.Tabs.Templates.Path} />}
    />
  </Route>
);

export { useMailAmbitionRoutes };
